/* eslint-disable */
export enum DspType {
  P2P = 'P2P',
  MULTISTOP = 'MULTISTOP',
}
